import { Route, Routes } from 'react-router-dom';

// basic routes
import PaymentList from '../components/Payments/PaymentList';
import EditPayment from '../components/Payments/EditPayment';
import ViewPayment from '../components/Payments/ViewPayment';


const Payments = () => {
  return (
    <Routes>
      <Route path="/" element={<PaymentList />} />
      <Route path="/edit/:id" element={<EditPayment />} />
      <Route path="/edit" element={<EditPayment />} />
      <Route path="/view/:id" element={<ViewPayment />} />
    </Routes>
  )
}

export default Payments;